import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ValuePair } from '../../interfaces/ValuePair';
import { isLocalUsingMeridianNotation } from '../../utils/meridian.helper';
import * as moment from 'moment';

@Component({
  selector: 'ls-time-form',
  styleUrls: ['./time.component.scss'],
  templateUrl: './time-form.component.html'
})
export class TimeFormComponent implements OnInit {
  @Input()
  public formGroup: FormGroup;
  @Input()
  public disabled: boolean;

  public timeForm: FormGroup;

  public hours: Array<ValuePair> = [];

  public minutes: Array<ValuePair> = [
    {
      value: '00',
      name: '00'
    },
    {
      value: '15',
      name: '15'
    },
    {
      value: '30',
      name: '30'
    },
    {
      value: '45',
      name: '45'
    }
  ];

  public readonly amPm: Array<ValuePair> = [
    {
      value: 'am',
      name: 'am'
    },
    {
      value: 'pm',
      name: 'pm'
    }
  ];

  public ngOnInit(): void {
    this.timeForm = this.formGroup;
    this.initHours();
    this.onChanges();
  }

  public onChanges(): void {
    this.timeForm.valueChanges.subscribe((formValues: any) => {
      if (formValues.meridian && formValues.hour > 12) {
        this.timeForm.controls.hour.setValue(12, { emitEvent: false });
      } else if (formValues.hour > 24) {
        this.timeForm.controls.hour.setValue(24, { emitEvent: false });
      } else if (formValues.hour < 0) {
        this.timeForm.controls.hour.setValue(0, { emitEvent: false });
      }

      if (formValues.minute < 0) {
        this.timeForm.controls.minute.setValue(0, { emitEvent: false });
      } else if (formValues.minute > 59) {
        this.timeForm.controls.minute.setValue(59, { emitEvent: false });
      }
      this.timeForm.controls.minute.setValue(
        this.formatTime(this.timeForm.controls.minute.value),
        { emitEvent: false }
      );
      this.timeForm.controls.hour.setValue(
        this.formatTime(this.timeForm.controls.hour.value),
        { emitEvent: false }
      );
    });
  }

  public formatTime(minute: number): string {
    return moment({ minute }).format('mm');
  }

  public getMaxHours(): number {
    return isLocalUsingMeridianNotation() ? 12 : 23;
  }

  private initHours(): void {
    const maxHours: number = this.getMaxHours();
    this.hours = [];
    for (let i = 0; i <= maxHours; i++) {
      this.hours.push({
        value: i < 10 ? `0${i}` : i + '',
        name: i < 10 ? `0${i}` : i + ''
      });
    }
  }
}
